import { render } from "./AuthModal.vue?vue&type=template&id=21b22738&scoped=true&ts=true"
import script from "./AuthModal.vue?vue&type=script&lang=ts"
export * from "./AuthModal.vue?vue&type=script&lang=ts"

import "./AuthModal.vue?vue&type=style&index=0&id=21b22738&scoped=true&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-21b22738"]])

export default __exports__